import Layout from './Layout.js';

export default class Grid extends Layout {
  constructor() {
    super('div', 'muigui-grid');
  }
}
